import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=8dc5d5da&scoped=true&"
import script from "./NewsInfo.vue?vue&type=script&lang=js&"
export * from "./NewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=8dc5d5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5d5da",
  null
  
)

component.options.__file = "NewsInfo.vue"
export default component.exports